import { inject, Injectable, signal } from '@angular/core';
import { CourseSearchApiService } from './course-search-api.service';
import { CoursesHubLink, TopDegreeSubject } from '../models/course-degree-hub.models';
import { DegreeLevelPayload } from '@uc/web/shared/data-models';

@Injectable({ providedIn: 'root' })
export class CourseSearchDataService {
	private _courseSearchApiSrv = inject(CourseSearchApiService);

	degreeLevelHubLinks = signal<CoursesHubLink[] | null>(null);

	topDegreeSubjects = signal<TopDegreeSubject[] | null>(null);
	isLoading = signal<boolean>(false);

	async fetchDegreeLevelHubLinks(type: 'DEGREE' | 'DIRECTORY') {
		try {
			const degreeLevelHubLinks =
				await this._courseSearchApiSrv.getDegreeLevelHubLinks(type);

			this.degreeLevelHubLinks.set(degreeLevelHubLinks);
		} catch (error) {
			console.error('Error fetching degree level hub links:', error);
		}
	}

	async fetchTopDegreeSubjects(
		type: 'DEGREE' | 'DIRECTORY',
		degreeLevel: DegreeLevelPayload,
	) {
		this.isLoading.set(true);

		try {
			const topDegreeSubjects = await this._courseSearchApiSrv.getTopSubjects(
				type,
				degreeLevel,
			);

			this.topDegreeSubjects.set(topDegreeSubjects);
		} finally {
			this.isLoading.set(false);
		}
	}
}
